import selectIcon from "../../../../assets/Image/SelectClear.png";
import "./ChipList.css";

const ChipList = ({
  items = [],
  onRemove,
  displayField = "title",
  keyField = "id",
  showRemoveIcon = true,
  className = "",
  chipClassName = "",
  style = {},
}) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={`chip-list-container ${className}`} style={style}>
      <div className="chip-list">
        {items.map((item, index) => {
          const key = item[keyField] || index;
          const displayValue = item[displayField] || item;
          return (
            <div className={`chip-card ${chipClassName}`} key={key}>
              <span className="chip-title">{displayValue}</span>
              {showRemoveIcon && onRemove && (
                <img
                  src={selectIcon}
                  alt="Remove"
                  className="chip-remove-icon"
                  onClick={() => onRemove(item)}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChipList;
